// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.filter-accordion-main {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid rgba(146, 146, 146, 0.4);
    .sub-main-division-line {
      padding: 21px 0px;
    }
    .sub-main-division-line.mobile {
      padding: 12px 0px;
    }
    .accordion {
      width: 100%;
      border: none;
      text-align: left;
      transition: 0.4s;
      background-color: #fff;
      flex: 1;
      padding: 0px;
      min-height: auto;
    }
    .accordion-text {
      display: flex;
    }
    .grids {
      flex: 1;
    }
    .heading-accordion {
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy4}px;
      font-weight: 800;
      text-transform: capitalize;
      font-family: Nunito;
      color: #1a1a1a;
      line-height: normal;
      letter-spacing: 0.64px;
    }
    .arrow-up {
      margin-top: 5px;
    }
    .arrow-down {
      margin-top: 5px;
    }
    .panel {
      padding: 0;
    }
    .panel-block {
      display: block;
      padding: 0 1px;
    }
    .panel-hidden {
      display: none;
    }
    .filter-label {
      outline: none;
      position: relative;
      display: inline-block;
      padding-right: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
      cursor: pointer;

      &:after {
        content: '';
        position: absolute;
        transform: rotate(45deg);
        width: 8px;
        height: 2px;
        background: ${(props) => props.theme.colorPalette.gray['1050']};
        top: 10px;
        right: 6px;
      }
      &:before {
        content: '';
        position: absolute;
        width: 8px;
        height: 2px;
        border-radius: 15px;
        background: ${(props) => props.theme.colorPalette.gray['1050']};
        top: 10px;
        right: 1px;
        bottom: 16px;
        transform: rotate(-45deg);
      }
    }
    .filter-label-expanded {
      margin-bottom: 16px;
      &:after {
        transform: rotate(-45deg);
      }
      &:before {
        transform: rotate(45deg);
      }
    }
  }
  &.filter-accordion-main.desktop:nth-last-child(1) {
    margin-bottom: 130px;
  }
  &.filter-accordion-main.mobile:nth-last-child(1) {
    margin-bottom: 40px;
  }
`;
